import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();

    const imgAllA = {
        JP: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724660147487/dd1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724660164309/dd2.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725096707515/eu1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725096707677/eu2.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725160836547/ukPC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725160836375/ukH5.jpg',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751007288319/X-boost.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751007288094/X-boost-h5.jpg',
        },
    };
    const imgLocaleA: any = {
        jp: imgAllA.JP,
        us: imgAllA.JP,
        br: imgAllA.JP,
        mx: imgAllA.JP,
        ca: imgAllA.JP,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        ph: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        ph: imgAllA.PH,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const configs = {
        pc: imgA.pc,
        h5: imgA.h5,
        label: t('E_label'),
        title: t('E_title'),
        position: 'hover',
        theme: 'white',
    };

    return (
        <div className={styles.TheComp}>
            <EfSection {...configs} />
        </div>
    );
}
